import { createFileRoute } from "@tanstack/react-router"
import { validateInstructorSectionSearch } from "@/utils/instructorSectionSearch"
import { queryClient } from "@/queryClient"
import { getCourseOptions } from "@/client/@tanstack/react-query.gen"
import InstructorTeamDetail from "@/routes/-pages/InstructorTeamDetail"
import { runBackendModePrefetch } from "@/utils/routePrefetch"

export const Route = createFileRoute("/instructor/course/$courseId/team/$teamId")({
  validateSearch: validateInstructorSectionSearch,
  loader: ({ params }) => {
    return runBackendModePrefetch(() =>
      queryClient.prefetchQuery(getCourseOptions({ path: { course_id: params.courseId } })),
    )
  },
  component: InstructorTeamDetail,
})
